import "../App.css"


function Introduction({ theme }) {
    return (
      <div className="page">
        <h1 className="title">Descope Zen Garden </h1>
        <p className="tagline">Showing how powerful and flexible Descope Flows can be</p>
      </div>
    )
}


export default Introduction
